"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var astrocite_core_1 = require("astrocite-core");
var constants_1 = require("./constants");
var EUtilsError = /** @class */ (function (_super) {
    __extends(EUtilsError, _super);
    function EUtilsError(message, data) {
        var _this = _super.call(this, message) || this;
        _this.uid = data.uid;
        _this.apiError = data.apiError || false;
        return _this;
    }
    return EUtilsError;
}(Error));
exports.EUtilsError = EUtilsError;
var transformUID = function (entry) {
    var database = entry.articleids.find(function (i) { return i.value.endsWith(entry.uid); });
    if (!database) {
        return { PMID: entry.uid };
    }
    return ['pubmed', 'pmid'].indexOf(database.idtype) !== -1
        ? { PMID: entry.uid }
        : { PMCID: database.value };
};
var transformAuthors = function (entry) {
    var author = entry.authors.map(function (a) {
        var _a = __read(a.name.split(' '), 2), family = _a[0], given = _a[1];
        return __assign({}, family ? { family: family } : {}, given ? { given: given } : {});
    });
    return { author: author };
};
var FIELD_TRANSFORMS = new Map([
    ['authors', transformAuthors],
    ['uid', transformUID],
    ['lang', function (entry) { return ({ language: entry.lang[0] }); }],
    ['sortdate', function (entry) { return ({ issued: astrocite_core_1.parseDate(entry.sortdate) }); }],
    ['sortpubdate', function (entry) { return ({ issued: astrocite_core_1.parseDate(entry.sortpubdate) }); }],
    [
        'source',
        function (entry) { return ({ journalAbbreviation: entry.source, 'container-title-short': entry.source }); },
    ],
]);
var parseEntry = function (entry) {
    if (entry.__astrocite_kind === 'error') {
        return new EUtilsError(entry.error, { uid: entry.uid });
    }
    return Object.keys(entry).reduce(function (obj, key) {
        if (!entry[key])
            return obj;
        var transform = FIELD_TRANSFORMS.get(key);
        var cslKey = constants_1.FIELD_MAP.get(key);
        if (transform) {
            return __assign({}, obj, transform(entry));
        }
        if (cslKey) {
            return __assign({}, obj, (_a = {}, _a[cslKey] = entry[key], _a));
        }
        return obj;
        var _a;
    }, { type: 'article-journal' });
};
function toCSL(input) {
    var entries = input.result.uids.map(function (id) { return (__assign({}, input.result[id], { __astrocite_kind: input.result[id].error ? 'error' : 'entry' })); });
    return __spread((input.error ? [new EUtilsError(input.error, { apiError: true })] : []), entries.map(parseEntry));
}
exports.toCSL = toCSL;
